import FMMatrix from '@/models/fm_matrix';
import axios from 'redaxios';

let loadingPromise;

export const foerderungenLoader = {
  methods: {
    loadFoerderungen() {
      if (!loadingPromise) {
        loadingPromise = axios.get('/api/fm_matrix').then(({ data }) => FMMatrix.insertOrUpdate({ data }));
      }
      return loadingPromise;
    }
  }
};
